import React from "react";

const TestimonialCard = ({ data }) => {
  return (
    <div className="bg-white shadow-[0_3px_8px_rgba(0,0,0,0.24)] backdrop-blur-[25px] w-[95%] md:w-[400px] h-[250px] rounded-xl p-6 flex flex-col justify-center items-start gap-[2rem]">
      <p className="font-Outfit text-[18px] font-light">{data.comments}</p>
      <h1 className="font-Syne text-[20px] font-bold ">{data.name}</h1>
    </div>
  );
};

export default TestimonialCard;
